// extracted by css-extract-rspack-plugin
export default {"icon":"_63334940","container":"_af110f6c"};